var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "px-3 py-3 fill-height", attrs: { tile: "" } },
    [
      _c(
        "span",
        [
          _vm.modalCheck
            ? _c(
                "div",
                { staticClass: "d-flex align-center" },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v("mdi-account-box")
                  ]),
                  _c("span", { staticClass: "title" }, [_vm._v("Contactos")])
                ],
                1
              )
            : _vm._e(),
          _c("v-text-field", {
            attrs: { label: "Buscar", "append-icon": "mdi-magnify" },
            model: {
              value: _vm.contactSearch,
              callback: function($$v) {
                _vm.contactSearch = $$v
              },
              expression: "contactSearch"
            }
          }),
          _vm.loadingContacts
            ? _vm._l(4, function(n, index) {
                return _c(
                  "span",
                  { key: index },
                  [
                    _c("v-skeleton-loader", {
                      staticClass: "mx-auto mb-6",
                      attrs: { "max-height": "30", type: "image" }
                    }),
                    _vm._l(3, function(n, index) {
                      return _c(
                        "span",
                        { key: index },
                        [
                          _c("v-skeleton-loader", {
                            staticClass: "mb-3",
                            attrs: { type: "heading" }
                          }),
                          n !== 3
                            ? _c("v-skeleton-loader", {
                                staticClass: "mb-2",
                                attrs: { type: "divider" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              })
            : !_vm.directoryList.length
            ? _c(
                "v-row",
                { staticClass: "d-flex justify-center" },
                [
                  _c("v-col", { staticClass: "justify-center" }, [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex justify-center",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        _vm.loadingDirectoryFailed
                          ? _c("h3", [
                              _vm._v(
                                " Carga de contactos fallida, por favor intente de nuevo "
                              )
                            ])
                          : _c("h3", [_vm._v("No hay contactos disponibles")])
                      ]
                    )
                  ])
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item-group",
                        [
                          _c(
                            "virtual-list",
                            {
                              attrs: {
                                size: _vm.size,
                                remain: _vm.contactToDisplay,
                                bench: 15
                              }
                            },
                            _vm._l(_vm.directory.contacts, function(
                              contactItem
                            ) {
                              return _c("directory-item", {
                                key: contactItem.id,
                                attrs: {
                                  directoryInfo: contactItem,
                                  isSelected: _vm.checkSelectedID(
                                    contactItem.id
                                  )
                                },
                                on: { contactClicked: _vm.emitContact }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }